import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { RSSISignalStrengthIndicator } from '../../common/RSSISignalStrengthIndicator';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const RSSISignalStrengthIndicatorWidget = () => {
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h6", children: "RSSI: 0 > -60" }), _jsx(RSSISignalStrengthIndicator, { rssi: -60 }), _jsx(Typography, { variant: "h6", children: "RSSI: -60 > -80" }), _jsx(RSSISignalStrengthIndicator, { rssi: -80 }), _jsx(Typography, { variant: "h6", children: "RSSI: -80 > -90" }), _jsx(RSSISignalStrengthIndicator, { rssi: -90 }), _jsx(Typography, { variant: "h6", children: "RSSI: -90 > -100" }), _jsx(RSSISignalStrengthIndicator, { rssi: -100 }), _jsx(Typography, { variant: "h6", children: "RSSI: -100 > -Inf" }), _jsx(RSSISignalStrengthIndicator, { rssi: -120 })] })), []);
    return {
        name: 'RSSISignalStrengthIndicator',
        category: 'common',
        component,
    };
};
